// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { DevelopmentScopeTemplateFragmentDoc } from '../DevelopmentScopeTemplates.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type CopyLineItemsModalQueryVariables = Types.Exact<{
  filter: Types.ItemTemplateFilter;
}>;


export type CopyLineItemsModalQuery = { __typename?: 'Query', itemTemplates: Array<{ __typename?: 'ItemTemplate', id: string, displayName: string }> };

export type CopyLineItemsItemTemplateFragment = { __typename?: 'ItemTemplate', id: string, displayName: string };

export type CopyItemTemplateMutationVariables = Types.Exact<{
  input: Types.CloneItemTemplateInput;
}>;


export type CopyItemTemplateMutation = { __typename?: 'Mutation', cloneItemTemplate: { __typename?: 'CloneItemTemplateResult', clone: { __typename?: 'ItemTemplate', id: string, displayName: string, isVersioned: boolean, displayVersion: string, createdAt: Types.Scalars['DateTime']['input'], updatedAt: Types.Scalars['DateTime']['input'], statusDetail: { __typename?: 'ItemTemplateStatusDetail', code: Types.ItemTemplateStatus, name: string }, hasCloneToTargets: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, readyPlan?: { __typename?: 'ReadyPlan', displayName: string, id: string, name: string, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus, name: string } } | null | undefined, canCreateNewVersion: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, basedOn?: { __typename?: 'ItemTemplate', id: string } | null | undefined } } };

export const CopyLineItemsItemTemplateFragmentDoc = gql`
    fragment CopyLineItemsItemTemplate on ItemTemplate {
  id
  displayName
}
    `;
export const CopyLineItemsModalDocument = gql`
    query CopyLineItemsModal($filter: ItemTemplateFilter!) {
  itemTemplates(filter: $filter) {
    ...CopyLineItemsItemTemplate
  }
}
    ${CopyLineItemsItemTemplateFragmentDoc}`;

/**
 * __useCopyLineItemsModalQuery__
 *
 * To run a query within a React component, call `useCopyLineItemsModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useCopyLineItemsModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCopyLineItemsModalQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCopyLineItemsModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CopyLineItemsModalQuery, CopyLineItemsModalQueryVariables> & ({ variables: CopyLineItemsModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CopyLineItemsModalQuery, CopyLineItemsModalQueryVariables>(CopyLineItemsModalDocument, options);
      }
export function useCopyLineItemsModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CopyLineItemsModalQuery, CopyLineItemsModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CopyLineItemsModalQuery, CopyLineItemsModalQueryVariables>(CopyLineItemsModalDocument, options);
        }
// @ts-ignore
export function useCopyLineItemsModalSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CopyLineItemsModalQuery, CopyLineItemsModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CopyLineItemsModalQuery, CopyLineItemsModalQueryVariables>;
export function useCopyLineItemsModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CopyLineItemsModalQuery, CopyLineItemsModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CopyLineItemsModalQuery | undefined, CopyLineItemsModalQueryVariables>;
export function useCopyLineItemsModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CopyLineItemsModalQuery, CopyLineItemsModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CopyLineItemsModalQuery, CopyLineItemsModalQueryVariables>(CopyLineItemsModalDocument, options);
        }
export type CopyLineItemsModalQueryHookResult = ReturnType<typeof useCopyLineItemsModalQuery>;
export type CopyLineItemsModalLazyQueryHookResult = ReturnType<typeof useCopyLineItemsModalLazyQuery>;
export type CopyLineItemsModalSuspenseQueryHookResult = ReturnType<typeof useCopyLineItemsModalSuspenseQuery>;
export type CopyLineItemsModalQueryResult = Apollo.QueryResult<CopyLineItemsModalQuery, CopyLineItemsModalQueryVariables>;
export const CopyItemTemplateDocument = gql`
    mutation CopyItemTemplate($input: CloneItemTemplateInput!) {
  cloneItemTemplate(input: $input) {
    clone {
      ...DevelopmentScopeTemplate
    }
  }
}
    ${DevelopmentScopeTemplateFragmentDoc}`;
export type CopyItemTemplateMutationFn = Apollo.MutationFunction<CopyItemTemplateMutation, CopyItemTemplateMutationVariables>;

/**
 * __useCopyItemTemplateMutation__
 *
 * To run a mutation, you first call `useCopyItemTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyItemTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyItemTemplateMutation, { data, loading, error }] = useCopyItemTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCopyItemTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CopyItemTemplateMutation, CopyItemTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CopyItemTemplateMutation, CopyItemTemplateMutationVariables>(CopyItemTemplateDocument, options);
      }
export type CopyItemTemplateMutationHookResult = ReturnType<typeof useCopyItemTemplateMutation>;
export type CopyItemTemplateMutationResult = Apollo.MutationResult<CopyItemTemplateMutation>;
export type CopyItemTemplateMutationOptions = Apollo.BaseMutationOptions<CopyItemTemplateMutation, CopyItemTemplateMutationVariables>;